import PropTypes from 'prop-types';
import React, { Suspense, useEffect, useState } from 'react';

import {Box, Link,  Button} from '@mui/material';
import store from "store2";

import {AzFooter, AzLogo, AzWidgetContactButton} from "@Development/ui-kit";

Footer.propTypes = {
  content: PropTypes.shape({
    aboutCompany: PropTypes.any,
    companyAddress: PropTypes.any,
    companyDetails: PropTypes.any,
    companyEmail: PropTypes.any,
    eSignatureAgreementLink: PropTypes.shape({
      text: PropTypes.any,
      url: PropTypes.any,
    }),
    icon: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fixed: PropTypes.any,
        fluid: PropTypes.any,
      }),
    }),
    privacyPolicyLink: PropTypes.shape({
      text: PropTypes.any,
      url: PropTypes.any,
    }),
    social: PropTypes.array,
  }),
};

export default function Footer({ content }) {
  const arenzaStorage = store.namespace('arenza');

  const [hidePolice, setHidePolice] = useState(arenzaStorage("police") || true);

  useEffect(() => {
    if (!arenzaStorage("police")) {
      setHidePolice(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onHide = () => {
    arenzaStorage("police", true)
    setHidePolice(true)
  }

  const renderBlockPolice = () => {
    if (hidePolice) return null;

    return (
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 106px',
          },
          gap: '24px',
          alignItems: 'center',
          position: "fixed",
          left: "50%",
          transform: "translate(-50%, 0)",
          bottom: "20px",
          background: "#ffffff",
          color: "#000000",
          padding: "30px",
          fontSize: {
            xs: "14px",
            md: "17px"
          },
          border: "1px solid #ebeced",
          zIndex: "50",
          minWidth: {
            xs:"96%",
            md:"300px"
          },
          borderRadius: "16px",
        }}>
          <span style={{color: '#6b6b6b'}}>Мы используем файлы cookie для вашего удобства. Продолжая пользоваться сайтом, вы соглашаетесь с политикой использования cookie. <Link href={`${process.env.GATSBY_DOCUMENTS_PUBLIC_URL}/cookies_consent.pdf`} sx={{color: '#000', textDecorationColor: '#000'}} target={'_blank'}>Подробнее</Link>.</span>

          <Button onClick={onHide} sx={{borderRadius: '18px', maxWidth: {xs: '150px', md: '106px'}, border: '1px solid #000', color: '#000', '&:hover': { border: '1px solid #000', color: '#000', background: '#fff' }}} variant='outlined'>Понятно</Button>
        </Box>
    )
  }

  return (
      <Suspense fallback={null}>
        <AzFooter urlRenew={`${process.env.GATSBY_SHOP_URL}`} urlLanding={`${process.env.GATSBY_ROOT_URL}`} positionIsAbsolute={false} />

        <AzWidgetContactButton />

        {renderBlockPolice()}
      </Suspense>
  );
}
